import useAPI from "./useAPI";
import React from "react";

export default function useAdminListBlogs(props) {
  const { onSave } = props;

  const { query: deleteBlog } = useAPI({
    type: "delete",
    url: `article`,
    defer: true,
  });

  const handleDelete = async (blogId) => {
    try {
      if (
        !window.confirm(
          `Êtes-vous sûr de vouloir supprimer cet article de blog ?`
        )
      ) {
        return;
      }

      await deleteBlog({
        url: `article/${blogId}`,
      });

      onSave({
        success: true,
        message: "Article de blog supprimé avec succès",
      });
    } catch (error) {
      console.error("Error deleting blog:", error);
      throw error;
    }
  };

  return {
    ...props,
    handleDelete,
  };
}
